import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const CardWrapper = styled.div`
  padding: 12px;
  background-color: var(--surface-default);
  border: 1px solid var(--border-soft);
  ${borderRadius.r2};
`;

export const Favicon = styled.img`
  width: 24px;
  height: 24px;
  ${borderRadius.rFull};
`;

export const Content = styled.div`
  display: flex;
  gap: 12px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  ${typographyV2.bodyBase};
`;

export const Url = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
